"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.952 8a2.65 2.65 0 0 1 2.65-2.65h4.795A2.65 2.65 0 0 1 13.047 8v3.349a2.65 2.65 0 0 1-2.65 2.65H5.602a2.65 2.65 0 0 1-2.65-2.65zm2.65-1.35A1.35 1.35 0 0 0 4.252 8v3.349c0 .746.605 1.35 1.35 1.35h4.795a1.35 1.35 0 0 0 1.35-1.35v-3.35a1.35 1.35 0 0 0-1.35-1.35z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.01 9.114a1.014 1.014 0 1 1-2.029 0 1.014 1.014 0 0 1 2.028 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.995 8.507a.65.65 0 0 1 .65.65v1.69a.65.65 0 1 1-1.3 0v-1.69a.65.65 0 0 1 .65-.65M4.223 3.149c-.98 0-1.773.794-1.773 1.774v.824a.7.7 0 1 1-1.4 0v-.824a3.174 3.174 0 0 1 6.347 0v1.524h-1.4V4.923c0-.98-.794-1.774-1.774-1.774",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=UnlockIcon16.js.map